const WIDGET_TYPE = 'callback';
const READY_TIMEOUT = 6000;
const RETRY_INTERVAL = 400;

interface CalltouchResult {
  error?: boolean;
  errorCode?: string | null;
}

type Calltouch = (
  module: string,
  section: string,
  action: string,
  widgetType: string,
  callback: (result: CalltouchResult) => void,
) => void;

export const openCalltouchWidget = () =>
  new Promise<void>(resolve => {
    if (!process.client) {
      resolve();
      return;
    }

    const startedAt = Date.now();
    let settled = false;

    const finish = () => {
      if (!settled) {
        settled = true;
        resolve();
      }
    };

    const attempt = () => {
      if (settled) {
        return;
      }

      if (Date.now() - startedAt >= READY_TIMEOUT) {
        finish();
        return;
      }

      const ct = (window as unknown as { ct?: Calltouch }).ct;

      if (typeof ct === 'function') {
        try {
          ct('modules', 'widgets', 'openExternal', WIDGET_TYPE, result => {
            if (!result?.error || result.errorCode === 'OPENED') {
              finish();
            }
          });
        } catch {}
      }

      window.setTimeout(attempt, RETRY_INTERVAL);
    };

    attempt();
  });
